// import Vue from 'vue';
// import Vuex from 'vuex';
// import VuexPersist from 'vuex-persist';
// import { WareHouseProConfig } from '@/models/warehouse-pro-config';
// import { WarehouseStaggingStatus } from './enums';
// import { CalendarEvent } from 'vuetify';

// import CryptoService from "@/services/crypto-services";
// const cryptoService = new CryptoService();

// // Vue.use(Vuex);

// const vuexPersist = new VuexPersist({
//   key: 'my-app',
//   storage: localStorage
// });

import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';
import { WareHouseProConfig } from '@/models/warehouse-pro-config';
import CryptoService from "@/services/crypto-services";
import { WarehouseStaggingStatus } from './enums';
import { CalnederEvent } from './models';
import { isProxy, toRaw } from 'vue';
import { getCurrentHub } from '@sentry/browser';

const vuexPersist = new VuexPersist({
    key: 'my-app',
    storage: localStorage
  });

export default createStore({
    state:{
        AgentId: '',
        SessionID: '',
        TenantId: '',
        userEmail: '',
        Password: '',
        TenantDesc: '',
        AgrisLicense:'',
        // adminUser: 'admin',
        // adminPassword: 'password1',
        isAdminLoggedIn: false,
        Permissions: [],
        tickets: [],
        plugins: [vuexPersist.plugin],
        packageVersion: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7B%7D')),
        Warehouse_Pro: new WareHouseProConfig(),
        AgentType: undefined,
        AgentEmail: undefined,
        AgentPassword:undefined,
        SalesOrders: [],
        StuckedContractEmailTemplates:[],
        SelectedPhysicalCount:[],
        AgentNames:[],
        ConnectedAgentInfo:null,
        ConnectedAgentName:null,
        ConnectedAgentId:null,
        Modules:[],
    },
    getters: {
        getAgentInfo(state) {
            return state;
        },
        getUserInfo(state) {
            return state;
        },
        getUserPermissions(state) {
            return state.Permissions;
        },
        appVersion: (state) => {
            return state.packageVersion
        },
        getIsAdminLoggedIn: (state) => {
            return state.isAdminLoggedIn
        },
        getAdminCredentails: (state) => {
        // return state.adminUser + ' ' + state.adminPassword;
        // return 'admin' + ' ' + 'password1';
        },
        getWareHouseProConfig: (state) => {
            let rawData = state.Warehouse_Pro;
            if (isProxy(state.Warehouse_Pro)){
                rawData = toRaw(state.Warehouse_Pro)
            }
            return rawData;
        },
        getAgentType: (state) => {
            return state.AgentType;
        },
        getSalesOrders: (state) => {
            return JSON.parse(JSON.stringify(state.SalesOrders));
        },
        getScheduleSalesOrders: (state: any) => {
            return state.SalesOrders.filter((x:CalnederEvent) => x.staggings.length > 0);
        },
        getUnScheduleSalesOrders: (state: any) => {
            return JSON.parse(JSON.stringify(state.SalesOrders.filter((x:CalnederEvent) => x.staggings.length == 0 && x.statusId != WarehouseStaggingStatus.ReadyToStage)));
        },
        getStuckedContractEmailTemplates: (state: any) => {
            let emailTemplates = JSON.parse(JSON.stringify(state.StuckedContractEmailTemplates));
            if(emailTemplates && emailTemplates.length)
                return emailTemplates;
            return [];
        },
        getSelectedPhysicalCount: (state) => {
            return state.SelectedPhysicalCount;
        },
        getSelectedPhysicalCountLocation: (state) => {
            return state.SelectedPhysicalCountLocation;
        },
        getSelectedPhysicalCountDeviceId: (state) => {
            return state.SelectedPhysicalCountDeviceId;
        },
        getTokenForActionListApis: (state) => {
            let rawData = state.TokenForActionListApis;
            if (isProxy(state.TokenForActionListApis)){
                rawData = toRaw(state.TokenForActionListApis)
            }
            return rawData;
        },
        getTokenForEsignApis: (state) => {
            let rawData = state.TokenForEsignApis;
            if (isProxy(state.TokenForEsignApis)){
                rawData = toRaw(state.TokenForEsignApis)
            }
            return rawData;
        },
        getAgentNames: (state) => {
            return JSON.parse(JSON.stringify(state.AgentNames));
        },
        getConnectedAgentName: (state) => {
            return JSON.parse(JSON.stringify(state.ConnectedAgentName));
        },
        getModules: (state) => {
            return JSON.parse(JSON.stringify(state.Modules));
        },
    
    },
    mutations: {
        setAgentInfo(state, payload) {
            state.AgentId = payload.AgentId;
            state.SessionID = payload.SessionID;
            state.TenantId = payload.TenantId;
            state.TenantDesc = payload.TenantDesc;
            state.AgentEmail = payload.AgentEmail;
            state.AgentPassword = payload.AgentPassword;
            
            if(payload.ConnectedAgentInfo){
                state.ConnectedAgentInfo = payload.ConnectedAgentInfo || "";
                state.ConnectedAgentName = payload.ConnectedAgentName || "";
               // state.ConnectedAgentId = payload.ConnectedAgentId || null;
            }
        },
        setUserInfo(state, payload) {
            state.userEmail = payload.userEmail;
            state.Password = payload.Password;
            state.Permissions = payload.Permissions;
            state.AgrisLicense = payload.AgrisLicense;
            if(payload.ConnectedAgentInfo){
                state.ConnectedAgentInfo = payload.ConnectedAgentInfo || "";
               // state.ConnectedAgentName = payload.ConnectedAgentName || "";
               // state.ConnectedAgentId = payload.ConnectedAgentId || null;
            }
        },
        setAdminLogin(state, payload) {
        state.isAdminLoggedIn = payload.isAdminLoggedIn;
        },
        updateTickets(state, payload) {
        state.tickets = payload.tickets;
        },
        initialiseStore(state) {
        let payload: any = localStorage.getItem('store');
        // Check if the ID exists
        if (payload) {
            payload = JSON.parse(payload);
            this.replaceState(Object.assign(state, payload), payload);
        }

        // // Check if the ID exists
        // if (localStorage.getItem('store')) {
        //   this.replaceState(
        //     Object.assign(state, JSON.parse(localStorage.getItem('store')))
        //   );
        // }
        },
        setWareHouseProConfig: (state, payload) => {
            state.Warehouse_Pro = payload;
        },
        setAgentType: (state, payload) => {
            state.AgentType = payload;
        },
        setSalesOrders: (state, payload) => {
            state.SalesOrders = payload;
        },
        setScheduleSalesOrders: (state, payload) => {
            state.SalesOrders = payload;
        },
        setStuckedContractEmailTemplates:(state, payload) => {
            state.StuckedContractEmailTemplates = payload;
        },
        setSelectedPhysicalCount: (state, payload) => {
            state.SelectedPhysicalCount = payload;
        },
        setSelectedPhysicalCountLocation: (state, payload) => {
            state.SelectedPhysicalCountLocation = payload;
        },
        setSelectedPhysicalCountDeviceId: (state, payload) => {
            state.SelectedPhysicalCountDeviceId = payload;
        },
        setTokenForActionListApis: (state, payload) => {
            state.TokenForActionListApis = payload;
        },
        setTokenForEsignApis: (state, payload) => {
            state.TokenForEsignApis = payload;
        },
        setAgentNames: (state, payload) => {
            state.AgentNames = payload;
        },
        SetModules: (state, payload) => {
            state.Modules = payload;
        },
        
  },
  actions: {

  },
  modules:{}
});


// export default new Vuex.Store({
//   state: {
//     AgentId: '',
//     SessionID: '',
//     TenantId: '',
//     userEmail: '',
//     Password: '',
//     TenantDesc: '',
//     // adminUser: 'admin',
//     // adminPassword: 'password1',
//     isAdminLoggedIn: false,
//     Permissions: [],
//     tickets: [],
//     plugins: [vuexPersist.plugin],
//     packageVersion: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7B%7D')),
//     Warehouse_Pro: new WareHouseProConfig(),
//     AgentType: undefined,
//     AgentEmail: undefined,
//     AgentPassword:undefined,
//     SalesOrders: []
//   },
//   getters: {
//     getAgentInfo(state) {
//       return state;
//     },
//     getUserInfo(state) {
//       return state;
//     },
//     getUserPermissions(state) {
//       return state.Permissions;
//     },
//     appVersion: (state) => {
//       return state.packageVersion
//     },
//     getIsAdminLoggedIn: (state) => {
//       return state.isAdminLoggedIn
//     },
//     getAdminCredentails: (state) => {
//       // return state.adminUser + ' ' + state.adminPassword;
//       // return 'admin' + ' ' + 'password1';
//     },
//     getWareHouseProConfig: (state) => {
//       return state.Warehouse_Pro;
//     },
//     getAgentType: (state) => {
//       return state.AgentType;
//     },
//     getSalesOrders: (state) => {
//       return state.SalesOrders;
//     },
//     getScheduleSalesOrders: (state: any) => {
//       return state.SalesOrders.filter((x:CalendarEvent) => x.staggings.length > 0);
//     },
//     getUnScheduleSalesOrders: (state: any) => {
//       return state.SalesOrders.filter((x:CalendarEvent) => x.staggings.length == 0 && x.statusId != WarehouseStaggingStatus.ReadyToStage);
//     }
    
//   },
//   mutations: {
//     setAgentInfo(state, payload) {
//       state.AgentId = payload.AgentId;
//       state.SessionID = payload.SessionID;
//       state.TenantId = payload.TenantId;
//       state.TenantDesc = payload.TenantDesc;
//       state.AgentEmail = payload.AgentEmail;
//       state.AgentPassword = payload.AgentPassword;
      

//     },
//     setUserInfo(state, payload) {
//       state.userEmail = payload.userEmail;
//       state.Password = payload.Password;
//       state.Permissions = payload.Permissions;
//     },
//     setAdminLogin(state, payload) {
//       state.isAdminLoggedIn = payload.isAdminLoggedIn;
//     },
//     updateTickets(state, payload) {
//       state.tickets = payload.tickets;
//     },
//     initialiseStore(state) {
//       let payload: any = localStorage.getItem('store');
//       // Check if the ID exists
//       if (payload) {
//         payload = JSON.parse(payload);
//         this.replaceState(Object.assign(state, payload), payload);
//       }

//       // // Check if the ID exists
//       // if (localStorage.getItem('store')) {
//       //   this.replaceState(
//       //     Object.assign(state, JSON.parse(localStorage.getItem('store')))
//       //   );
//       // }
//     },
//     setWareHouseProConfig: (state, payload) => {
//       state.Warehouse_Pro = payload;
//     },
//     setAgentType: (state, payload) => {
//       state.AgentType = payload;
//     },
//     setSalesOrders: (state, payload) => {
//       state.SalesOrders = payload;
//     },
//     setScheduleSalesOrders: (state, payload) => {
//       state.SalesOrders = payload;
//     }
//   },
//   actions: {

//   }
// });
